import {
  Flex,
  Box,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Link as ChakraLink,
} from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';
import React from 'react';
import Card from './Card';

const ProviderParams = ({ id, title, params }) => {
  const textColor = useColorModeValue('gray.700', 'white');

  return (
    <Card minH="83px">
      <Box display="flex" width="100%">
        <Flex flexDirection="row" align="center" justify="center" w="100%">
          <Stat me="auto">
            <StatLabel fontSize="sm" fontWeight="bold" pb=".1rem">
              <ChakraLink
                color="teal.500"
                as={ReactRouterLink}
                to={`/admin_area/terminals/${id}`}
              >
                {title}
              </ChakraLink>
            </StatLabel>
            <Flex>
              <StatNumber fontSize="sm" fontWeight="normal" color={textColor}>
                {params}
              </StatNumber>
            </Flex>
          </Stat>
        </Flex>
      </Box>
    </Card>
  );
};

export default ProviderParams;
